import styled from 'styled-components';
import { GlobalToken } from 'antd';

import EpModal from '@/comp/EPModal';

import { EngineStepsContainer, getTableCss } from '../Engine/Common/styled';
import EngineVersion from '../EngineVersion';
import { EngineVersionContainer } from '../styled';
import { FallbackOverviewContainer } from '../FallbackOverview/styled';
import { CheckboxContainer, DefaultRuleContainer } from '../Engine/DefaultRule/styled';
import { Modal } from 'antd';
import {
  CentrifugalVersionContainer,
  CompressorParametersContainer,
  StationParametersContainer,
} from '../Engine/CentrifugalCompressors/styled';

export const VersionHistoryContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme: { token } }) => token.paddingXL}px ${({ theme: { token } }) => token.padding}px
    ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.padding}px;
  margin-top: ${({ theme: { token } }) => token.marginXXL}px;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};

  .table-row:hover td {
    background-color: ${({ theme: { token } }) => token.colorBgElevated} !important;
    cursor: pointer;
  }

  ${({ theme: { token } }) => getTableCss(token)}

  .table {
    .ant-table-thead > tr > th,
    .ant-table-header {
      background-color: ${({ theme: { token } }) => token.colorBgElevated} !important;
    }

    .ant-table .ant-table-tbody > tr > td:first-child,
    .ant-table .ant-table-thead > tr > th:first-child {
      padding-left: ${({ theme: { token } }) => token.paddingXL}px;
    }

    .ant-table-tbody .ant-table-cell {
      padding: ${({ theme: { token } }) => token.padding}px !important;
      height: 68px;
    }

    .ant-table-thead > tr > th,
    .ant-table-header {
      background-color: ${({ theme: { token } }) => token.colorBgElevated};
    }
  }

  .action-buttons {
    display: flex;

    span {
      display: flex;
      gap: 10px;
    }
  }
`;

export const StyledEngineVersion = styled(EngineVersion)`
  .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-tab .ant-tabs-tab-btn {
    cursor: pointer !important;
  }
`;

export const TableCell = styled.span<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorTextTertiary};
`;

export const StyledEPModal = styled(EpModal)<{ theme: { token: GlobalToken } }>`
  .ant-modal-content {
    height: auto;
    .ant-modal-close {
      top: ${({ theme: { token } }) => token.marginLG}px;
      right: ${({ theme: { token } }) => token.marginLG}px;
    }
    .ant-modal-body {
      display: flex;
      padding: 0px;

      .engine-version-one-alert-container {
        display : none;
      }

      ${EngineVersionContainer} {
        width: 100%;
        .engine-tabs-container {
          padding: ${({ theme: { token } }) => token.paddingLG}px;
        }
        .ant-input {
          border: none;
          color: ${({ theme: { token } }) => token.colorBorder};
          text-align: center;
          height: 18px;
          text-decoration: none;
        }
        .ant-checkbox-inner {
          border-color: ${({ theme: { token } }) => token.colorBorder};
        }
        .ant-table {
          color: ${({ theme: { token } }) => token.colorBorder};
        }
      }

      ${FallbackOverviewContainer} {
        width: 1100px;
        margin: 0;
      }

      ${EngineStepsContainer} {
        height: 80%;
      }

      ${DefaultRuleContainer} {
        pointer-events: auto;

        .ant-table-cell {
          pointer-events: none;

          span {
            pointer-events: auto;
          }
        }

        .ant-select-selector {
          pointer-events: none;
        }

        ${CheckboxContainer} {
          pointer-events: none;
        }
      }
    }
  }
`;

export const StyledVersionHistoryCentrifugalModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
  ${CentrifugalVersionContainer} {
    .centrifugal-tab-container {
      background-color: ${({ theme: { token } }) => token.colorBgElevated};
    }

    overflow-y: scroll;
    height: 40rem;
    padding: 0;
    .ant-tabs-tab {
      width: 100%;
      color: ${({ theme: { token } }) => token.colorText};
    }
  }

  ${StationParametersContainer} {
    .ant-table-content {
      pointer-events: none;
      .ant-table-thead {
        th {
          &:before {
            background-color: transparent;
          }
        }
      }

      .ant-table-tbody {
        tr {
          td {
            .ant-form-item {
              .ant-row {
                width: 6rem;
              }
              .ant-form-item-control-input {
                .ant-form-item-control-input-content {
                  input {
                    border: none;
                  }
                  span {
                    border: none;
                  }
                }
              }
            }
          }
        }
      }

      overflow: auto;
    }

    .ant-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
      margin: 0;
    }

    form {
      width: 100%;
    }
  }

  ${CompressorParametersContainer} {
    pointer-events: none;
  }

  .ant-modal-content {
    padding: ${({ theme: { token } }) => token.paddingMD}px;
    background-color: ${({ theme: { token } }) => token.colorBgElevated};

    .ant-modal-close {
      color: ${({ theme: { token } }) => token.colorText};
    }

    .ant-modal-title {
      color: ${({ theme: { token } }) => token.colorText};
      background-color: ${({ theme: { token } }) => token.colorBgElevated};
    }
  }
`;

export const VersionAlertContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: inline-block;
  .version-alert-box {
    color: ${({ theme: { token } }) => token.colorWarning};
  }
`;
